import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Close from '@mui/icons-material/Close';
import * as Yup from 'yup';
import { MerchantTitle } from 'app/MerchantTitle';
import { MuiAppBar } from 'lib/appbar/MuiAppBar';
import { Throbber } from 'lib/Throbber';
import { ApplicationState } from 'store/store';
import { LoginForm } from './LoginForm';

interface LogInProps {
    message?: string;
}

// The `or` Yup method is registered globally so other forms (and the extracted LoginForm) can
// rely on it. Registration must happen before any schema that uses `or` is evaluated.
Yup.addMethod(Yup.string, 'or', function (schemas: Yup.Schema[], msg: string) {
    // TODO: find better way to do this
    return (this as unknown as any).test({
        name: 'or',
        message: msg || 'Please enter valid url or email.',
        test: (value: string) => {
            if (Array.isArray(schemas) && schemas.length > 1) {
                const resee = schemas.map(schema => schema.isValidSync(value));
                return resee.some(res => res);
            }
            throw new TypeError('Schemas is not correct array schema');
        },
        exclusive: false
    });
});

export const LogIn: React.FC<React.PropsWithChildren<LogInProps>> = () => {
    const { t } = useTranslation();
    const { isLoading } = useSelector((state: ApplicationState) => state.settings);

    if (isLoading) {
        return <Throbber text={t('GENERAL_LOADING')} />;
    }

    return (
        <>
            <MerchantTitle title={t('ONBOARDING_SIGN_IN')} />
            <MuiAppBar title={t('ONBOARDING_SIGN_IN')} icon={Close} disabledMenu />
            <LoginForm />
        </>
    );
};
